module.exports = __webpack_public_path__ + "static/media/Rafael_Daron.440bb8fc.jpg";